import { render } from "./MainReviewsSlider.vue?vue&type=template&id=cb305cc0"
import script from "./MainReviewsSlider.vue?vue&type=script&lang=js"
export * from "./MainReviewsSlider.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__